import { AppState } from "../../reducers";
import { LoginState } from "./reducer";

export const loginSelector = (state: AppState): LoginState => {
  return state.login;
};
